var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main" }, [
    _c("div", { staticClass: "banner" }, [
      _c(
        "div",
        { staticClass: "slider" },
        _vm._l(
          _vm.isMobile ? _vm.bannerData2 : _vm.bannerData,
          function (item, index) {
            return _c("div", { key: item.id, staticClass: "item" }, [
              _c("a", { staticClass: "con" }, [
                _c("div", {
                  staticClass: "bg",
                  class: { loaded: _vm.imageLoaded[index] },
                  style: {
                    "background-image": "url(" + item.carouselBackUrl + ")",
                  },
                }),
              ]),
            ])
          }
        ),
        0
      ),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "case_slick3_dots" },
        _vm._l(_vm.bannerData, function (item, index) {
          return _c("li", { key: item.id, class: { base: index === 0 } }, [
            _vm._m(0, true),
            _vm._v(" "),
            _vm._m(1, true),
          ])
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "row-a1 is-show-product-pc",
        staticStyle: { position: "relative", height: "30vw" },
      },
      [
        _vm._m(2),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "m-slider1 wow fadeInUp mob-product",
            staticStyle: {
              "word-wrap": "nowrap",
              display: "flex",
              "justify-content": "space-between",
            },
            attrs: { "data-wow-duration": "1.5s", "data-wow-delay": "0.3s" },
          },
          _vm._l(_vm.productData, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "product-item",
                on: {
                  click: function ($event) {
                    return _vm.$router.push("/product-center?id=" + item.id)
                  },
                },
              },
              [
                _c("div", { staticClass: "product-img-container" }, [
                  _c("img", {
                    staticClass: "i-on",
                    attrs: { src: item.image2, alt: "" },
                  }),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "i-ok",
                    attrs: { src: item.image2, alt: "" },
                  }),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("h3", [_vm._v(_vm._s(item.name))]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(item.desc))]),
                  _vm._v(" "),
                  _vm._m(3, true),
                ]),
                _vm._v(" "),
                _vm._m(4, true),
              ]
            )
          }),
          0
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "row-a1 is-show-product-phone",
        staticStyle: { "background-image": "none" },
      },
      [
        _vm._m(5),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "m-slider1 wow fadeInUp mob-product",
            attrs: { "data-wow-duration": "1.5s", "data-wow-delay": "0.3s" },
          },
          _vm._l(_vm.productData, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "product-item",
                on: {
                  click: function ($event) {
                    return _vm.$router.push(
                      "/product-center?type=mobile&id=" + item.id
                    )
                  },
                },
              },
              [
                _c("div", { staticClass: "product-img-container" }, [
                  _c("img", {
                    staticClass: "i-on",
                    attrs: { src: item.image, alt: "" },
                  }),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "i-ok",
                    attrs: { src: item.image2, alt: "" },
                  }),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("h3", [_vm._v(_vm._s(item.name))]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(item.desc))]),
                  _vm._v(" "),
                  _vm._m(6, true),
                ]),
                _vm._v(" "),
                _vm._m(7, true),
              ]
            )
          }),
          0
        ),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticStyle: { position: "relative" } }, [
      _vm._m(8),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "app-center" }, [
          _c(
            "div",
            {
              staticClass: "app-item-1 wow fadeInLeft",
              attrs: { "data-wow-duration": "0.8s", "data-wow-delay": "0.2s" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "app-item-inner",
                  on: {
                    click: function ($event) {
                      return _vm.$router.push("/app-center?id=18")
                    },
                  },
                },
                [
                  _c("div", { staticClass: "app-item-title" }, [
                    _vm._v("通信解决方案"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "app-item-tips" }, [
                    _vm._v("Communication soluti"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "app-item-line" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "app-item-desc" }, [
                    _vm._v("暂无描述"),
                  ]),
                  _vm._v(" "),
                  _vm._m(9),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "app-item-2 wow fadeInLeft",
              attrs: { "data-wow-duration": "0.8s", "data-wow-delay": "0.4s" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "app-item-inner",
                  on: {
                    click: function ($event) {
                      return _vm.$router.push("/app-center?id=19")
                    },
                  },
                },
                [
                  _c("div", { staticClass: "app-item-title" }, [
                    _vm._v("雷达解决方案"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "app-item-tips" }, [
                    _vm._v("Radar solutions"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "app-item-line" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "app-item-desc" }, [
                    _vm._v("暂无描述"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "app-item-more",
                      on: {
                        click: function ($event) {
                          return _vm.$router.push("/app-center?id=19")
                        },
                      },
                    },
                    [
                      _c("div", [_vm._v("查看详情")]),
                      _vm._v(" "),
                      _c("div", { staticStyle: { color: "#333" } }, [
                        _vm._v("→"),
                      ]),
                    ]
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "app-item-3 wow fadeInLeft",
              attrs: { "data-wow-duration": "0.8s", "data-wow-delay": "0.6s" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "app-item-inner",
                  on: {
                    click: function ($event) {
                      return _vm.$router.push("/app-center?id=20")
                    },
                  },
                },
                [
                  _c("div", { staticClass: "app-item-title" }, [
                    _vm._v("测试解决方案"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "app-item-tips" }, [
                    _vm._v("Test solutions"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "app-item-line" }),
                  _vm._v(" "),
                  _vm._m(10),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "app-item-more",
                      on: {
                        click: function ($event) {
                          return _vm.$router.push("/app-center?id=20")
                        },
                      },
                    },
                    [
                      _c("div", [_vm._v("查看详情")]),
                      _vm._v(" "),
                      _c("div", { staticStyle: { color: "#333" } }, [
                        _vm._v("→"),
                      ]),
                    ]
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "app-item-4 wow fadeInLeft",
              attrs: { "data-wow-duration": "0.8s", "data-wow-delay": "0.8s" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "app-item-inner",
                  on: {
                    click: function ($event) {
                      return _vm.$router.push("/app-center?id=21")
                    },
                  },
                },
                [
                  _c("div", { staticClass: "app-item-title" }, [
                    _vm._v("其他解决方案"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "app-item-tips" }, [
                    _vm._v("Other solutions"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "app-item-line" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "app-item-desc" }, [
                    _vm._v("暂无描述"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "app-item-more",
                      on: {
                        click: function ($event) {
                          return _vm.$router.push("/app-center?id=21")
                        },
                      },
                    },
                    [
                      _c("div", [_vm._v("查看详情")]),
                      _vm._v(" "),
                      _c("div", { staticStyle: { color: "#333" } }, [
                        _vm._v("→"),
                      ]),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-list" },
      _vm._l(_vm.tablesListData, function (item, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "table-list-item",
            on: {
              click: function ($event) {
                return _vm.$router.push(item.url)
              },
            },
          },
          [
            _c("img", { attrs: { src: item.backgroundImg, alt: "" } }),
            _vm._v(" "),
            _c("div", { staticClass: "table-list-item-title" }, [
              _vm._v(_vm._s(item.title)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "table-list-item-desc" }, [
              _vm._v(_vm._s(item.desc)),
            ]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "numb" }, [_c("i")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "wrapper" }, [
      _c("div", { staticClass: "circle left" }),
      _vm._v(" "),
      _c("div", { staticClass: "circle right" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "g-t1 wow fadeInUp dis-title",
        staticStyle: {
          "z-index": "10000",
          position: "absolute",
          top: "0",
          left: "0",
          right: "0",
          margin: "0 auto",
        },
        attrs: { "data-wow-duration": "1.5s", "data-wow-delay": "0.2s" },
      },
      [
        _c("em", [_vm._v("product")]),
        _vm._v(" "),
        _c("h2", { staticStyle: { color: "#fff" } }, [_vm._v("产品中心")]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "line" }, [_c("div")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "product-btn-detail" }, [
      _c("div", [_vm._v("查看详情")]),
      _vm._v(" "),
      _c("div", [_vm._v("→")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "g-t1 wow fadeInUp",
        attrs: { "data-wow-duration": "1.5s", "data-wow-delay": "0.2s" },
      },
      [
        _c("em", [_vm._v("product")]),
        _vm._v(" "),
        _c("h2", { staticStyle: { color: "#222" } }, [_vm._v("产品中心")]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "line" }, [_c("div")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "product-btn-detail" }, [
      _c("div", [_vm._v("查看详情")]),
      _vm._v(" "),
      _c("div", [_vm._v("→")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "g-t1 wow fadeInUp ishowUING",
        staticStyle: {
          "z-index": "10000",
          position: "absolute",
          top: "0",
          left: "0",
          right: "0",
          margin: "0 auto",
        },
        attrs: { "data-wow-duration": "1.5s", "data-wow-delay": "0.2s" },
      },
      [
        _c("em", [_vm._v("DOCUMENT")]),
        _vm._v(" "),
        _c("h2", { staticStyle: { color: "#fff" } }, [_vm._v("应用中心")]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "app-item-more" }, [
      _c("div", [_vm._v("查看详情")]),
      _vm._v(" "),
      _c("div", { staticStyle: { color: "#333" } }, [_vm._v("→")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "app-item-desc typing-demo" }, [
      _c("div", [_vm._v("包括各种规格的微波器件和天线，有超强的系统配")]),
      _vm._v(" "),
      _c("div", [_vm._v("套和组合能力，能为客户提供整体方案")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }